module.exports = __webpack_public_path__ + "static/theme-editor-products-by-category-e3cd1a401c6e504e7b917f5f8fceeb26.png";